import { render, staticRenderFns } from "./channelSelect.vue?vue&type=template&id=10e14837"
import script from "./channelSelect.vue?vue&type=script&lang=js"
export * from "./channelSelect.vue?vue&type=script&lang=js"
import style0 from "./channelSelect.vue?vue&type=style&index=0&id=10e14837&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports